import { Controller } from "@hotwired/stimulus";
import { getCSRFToken } from "../../javascripts/utils";

export default class extends Controller {
  private TWENTY_FOUR_HOURS = 86400e3;
  private SUBSCRIPTION_ENDPOINT = "/subscription/expiry_banner/dismiss";
  private COOKIE_NAME = "bm_banner_type";

  dismiss(e: Event) {
    // get the banner type
    const bannerType = this.getCookieType(e.target);
    const expiryDate = this.getExpiryDate();

    // remove the banner
    this.element.remove();

    // If the banner is an expired subscription then we will send a request off to the server
    // to increment the dismissal count by 1
    if (bannerType == "expired") {
      this.incrementDismissalCount();
    }

    // Set a cookie to hide the banner for 24 hours
    document.cookie = `${this.COOKIE_NAME}=${bannerType}; expires=${expiryDate}`;

    // When a banner is dismissed make sure we stick the header back to the top as
    // this could be "auto" in a scenario where the expiry banner is sticky.
    const header = document.querySelector(".bm-header") as HTMLElement;
    header.style.top = "0";
  }

  incrementDismissalCount() {
    const requestOptions = {
      method: "POST",
      headers: {
        "X-CSRF-Token": getCSRFToken(),
      },
    };
    fetch(this.SUBSCRIPTION_ENDPOINT, requestOptions);
  }

  getCookieType(el: EventTarget) {
    if (el instanceof HTMLElement) {
      return el.dataset.type;
    }
  }

  getExpiryDate() {
    const date = new Date(Date.now() + this.TWENTY_FOUR_HOURS);
    return date.toUTCString();
  }
}
